import { Navigate, Route, Routes } from 'react-router'
import { AssignNumberStepsRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber'
import { BuyNumberStepsRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber'
import { InboxesRoutes } from 'pages/settings/pages/inboxes/route/type'
import { AddNumberFromAppRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp'
import { TextEnableLandlineRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline'

export const AddNumberMethodsRouter = () => {
  return (
    <Routes>
      <Route path={`${InboxesRoutes.assignNumber}/*`} element={<AssignNumberStepsRouter />} />
      <Route path={`${InboxesRoutes.buyNumber}/*`} element={<BuyNumberStepsRouter />} />
      <Route path={`${InboxesRoutes.addNumberFromApp}/*`} element={<AddNumberFromAppRouter />} />
      <Route
        path={`${InboxesRoutes.textEnableLandline}/*`}
        element={<TextEnableLandlineRouter />}
      />
      <Route path={'*'} element={<Navigate to={''} />} />
    </Routes>
  )
}
